import axios, { AxiosRequestHeaders } from 'axios';
import { ApplicationType, x_app_type } from 'application/constants/apiHeaders';

// Create an instance of axios without token authentication
const axiosNonTokenInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-type': 'Application/json',
    [x_app_type]: ApplicationType.HrDepartmentWeb,
  },
});

// Add a request interceptor to the instance
axiosNonTokenInstance.interceptors.request.use(
  async (config) => {
    // Perform a task before the request is sent
    if (!config.headers) {
      config.headers = {} as AxiosRequestHeaders;
    }

    return config;
  },
  (error) => {
    console.error('[API] request ERROR: ', error);
    // Handle the error
    return Promise.reject(error);
  },
);

// Add a response interceptor to the instance
axiosNonTokenInstance.interceptors.response.use(
  (response) => {
    // Handle response data
    return response;
  },
  (error) => {
    if (error.response) {
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log('Error', error.message);
    }
    console.log('[API] response ERROR: ', error);
    // Handle the response error
    return Promise.reject(error);
  },
);

// Export the instance for use in other parts of the application
export default axiosNonTokenInstance;
